export const GET_COMPANY_DASH_API_START = 'GET_COMPANY_DASH_API_START';
export const GET_COMPANY_DASH_API_SUCCESS = 'GET_COMPANY_DASH_API_SUCCESS';
export const GET_COMPANY_DASH_API_SUCCESS_LIFE = 'GET_COMPANY_DASH_API_SUCCESS_LIFE';

export const GET_COMPANY_DASH_API_FAILURE = 'GET_COMPANY_DASH_API_FAILURE';
export const GET_COMPANY_DASH_API_RESET = 'GET_COMPANY_DASH_API_RESET';


// LOB wise Net Premium API

export const GET_LOB_PREMIUM_API_START = 'GET_LOB_PREMIUM_API_START'
export const GET_LOB_PREMIUM_API_SUCCESS_Life = 'GET_LOB_PREMIUM_API_SUCCESS_Life'
export const GET_LOB_PREMIUM_API_SUCCESS_Gen = 'GET_LOB_PREMIUM_API_SUCCESS_Gen'

export const GET_LOB_PREMIUM_API_FAIL = 'GET_LOB_PREMIUM_API_FAIL'
export const GET_LOB_PREMIUM_API_RESET = 'GET_LOB_PREMIUM_API_RESET'

export const SHOW_PRIVACY_MODAL = 'SHOW_PRIVACY_MODAL'


// EMPLOYEE GRAPH

export const GET_EMPLOYEE_API_START = 'GET_EMPLOYEE_API_START';
export const GET_EMPLOYEE_API_SUCCESS = 'GET_EMPLOYEE_API_SUCCESS';
export const GET_EMPLOYEE_API_FAIL = 'GET_EMPLOYEE_API_FAIL';
export const GET_EMPLOYEE_API_RESET = 'GET_EMPLOYEE_API_RESET';


// To SHow dashboard graph

export const GET_COMPANY_GRAPH = "GET_COMPANY_GRAPH"
export const GET_COMPANY_GRAPH_SUCCESS = "GET_COMPANY_GRAPH_SUCCESS"
export const GET_COMPANY_LIFE_GRAPH_SUCCESS = "GET_COMPANY_LIFE_GRAPH_SUCCESS"
export const GET_COMPANY_GRAPH_FAILED = "GET_COMPANY_GRAPH_FAILED"



export const GET_LOB_GRAPH = "GET_LOB_GRAPH"
export const GET_LOB_GRAPH_SUCCESS = "GET_LOB_GRAPH_SUCCESS"
export const GET_LOB_LIFE_GRAPH_SUCCESS = "GET_LOB_LIFE_GRAPH_SUCCESS"
export const GET_LOB_GRAPH_FAILED = "GET_LOB_GRAPH_FAILED"